import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=3d816d1e"
import script from "./BaseBanner.vue?vue&type=script&lang=js"
export * from "./BaseBanner.vue?vue&type=script&lang=js"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=3d816d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports